import React, { useEffect } from "react";


export default function PdfPreviewModal({ isOpen, onClose, pdfUrl, title = "Document" }) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", handleKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="
          bg-white w-full sm:w-[90vw] md:w-[80vw] lg:w-[70vw]
          h-[72vh] sm:h-[88vh] lg:h-[70vh]
          sm:max-w-3xl sm:rounded-2xl
          rounded-t-2xl sm:rounded-b-2xl
          shadow-xl flex flex-col overflow-hidden
        "
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 shrink-0">
          <p className="font-semibold text-gray-900 text-sm truncate pr-2">{title}</p>
          <button
            onClick={onClose}
            aria-label="Close"
            className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center shrink-0"
          >
            <svg className="w-4 h-4 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* PDF viewer */}
        {/* <div className="flex-1 bg-gray-100 min-h-0">
          <iframe src={pdfUrl} title={title} className="w-full h-full border-none" />
        </div> */}
        <div className="flex-1 bg-gray-100 min-h-0">
  <iframe
    src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
    title={title}
    className="w-full h-full border-none"
  />
</div>
      </div>
    </div>
  );
}